import {
  IOverleveringChecklistReport,
  IOverleveringChecklistType,
  OVERLEVERING_CHECKLIST_TYPES,
} from "../../../../mc-shared/reportSchemas/startupChecklistSchema";

export const ensureOverleveringChecklistReport = (
  data: Partial<IOverleveringChecklistReport> | null | undefined,
): IOverleveringChecklistReport => ({
  overleveringChecklistType: data?.overleveringChecklistType ?? OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING,
  overleveringChecklistMeta: {
    title: data?.overleveringChecklistMeta?.title ?? "",
    oppdragsnummer: data?.overleveringChecklistMeta?.oppdragsnummer ?? "",
    oppdragsnavn: data?.overleveringChecklistMeta?.oppdragsnavn ?? "",
  },
  rows: data?.rows ?? [],
});

export const getOverleveringChecklistTitle = (type: IOverleveringChecklistType): string => {
  switch (type) {
    case OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING:
      return "Sjekkliste for overlevering av oppdrag fra TA og TL til OA og OL";
  }
};
